<!--begin::Body-->
<div class="kt-login__body">
	<!--begin::Signin-->
	<div class="kt-login__form">
		<div class="kt-login__title">
			<img src="./assets/media/logos/key.png" alt="" style="width:110px; height: 110px;">
		</div>

		<div class="kt-login__title" style="font-family:Conv_WuerthExtraBoldCond;">
			<h3 style="color:whitesmoke">Cambiar Contraseña</h3>
		</div>

		<kt-auth-notice></kt-auth-notice>

		<form class="kt-form" [formGroup]="forgotPasswordForm" autocomplete="off">
			<div class="form-group">
				<!--<mat-form-field >
					<mat-label style="font-family:Conv_WuerthBold; font-size:24px; color: #17253d">{{ 'AUTH.INPUT.EMAIL' | translate }}</mat-label>
					<input matInput type="email" placeholder="{{ 'AUTH.INPUT.EMAIL' | translate }}" formControlName="email" autocomplete="off"/>
					<mat-error *ngIf="isControlHasError('email','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('email','email')">
						<strong>{{ 'AUTH.VALIDATION.INVALID_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('email','minLength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('email','maxLength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 320</strong>
					</mat-error>
				</mat-form-field>-->
				<mat-form-field>
					<mat-label style="font-family:Conv_WuerthBold; font-size:22px; color: whitesmoke">Nueva Contraseña
					</mat-label>
					<input matInput type="password" formControlName="password" autocomplete="off" />
				</mat-form-field>
				<mat-form-field>
					<mat-label style="font-family:Conv_WuerthBold; font-size:22px; color: whitesmoke">Confirmar
						Contraseña</mat-label>
					<input matInput type="password" formControlName="passwordConfirmation" autocomplete="off" />
				</mat-form-field>
			</div>
			<div class="mt-3">
				<span style="color: whitesmoke">* La contraseña no debe ser menor a 6 caracteres y no mayor a 15 caracteres.</span><br>
				<span style="color: whitesmoke">** Se recomienda por seguridad use combinacion de letras mayúsculas, minúsculas, números,
					símbolos.</span>
			</div>
			<!--begin::Action-->
			<div class="kt-login__actions">
				<button routerLink="/login" [disabled]="loading" id="kt_login_signup_cancel"
					style="font-family: Conv_WuerthBold; font-size:17px; background-color: #7a8588;"
					class="btn btn-dark btn-elevate kt-login__btn-secondary">{{ 'AUTH.GENERAL.BACK_BUTTON' | translate
					}}</button>
				<button (click)="submit()" id="kt_login_signin_submit"
					class="btn btn-info btn-elevate kt-login__btn-primary"
					style="font-family: Conv_WuerthBold; font-size:17px; background: #29b0d1; border: #29b0d1"
					[ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}">{{
					'AUTH.GENERAL.SUBMIT_BUTTON' | translate }}</button>
			</div>
			<!--end::Action-->
		</form>
	</div>
</div>
